import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../api/store";
import { AnnualPremiumEoiState } from "./annual-premium-eoi.state";

const initialState: AnnualPremiumEoiState = {
    annualPremiumAmount: null,
    nmlValue: "",
    nelValue: "",
    evidenceNotes: "",
    isUpdateAnnualPremium: false,
    isEvidenceOfInsurability: false,
};

const annualPremiumEoiSlice = createSlice({
    name: "annualPremiumEoiSlice",
    initialState,
    reducers: {
        setAnnualPremiumAmount: (state, action: PayloadAction<number | null>) => {
            state.annualPremiumAmount = action.payload;
        },
        setEvidenceNotes: (state, action: PayloadAction<string>) => {
            state.evidenceNotes = action.payload;
        },
        setIsUpdateAnnualPremiumAndIoE: (state, action: PayloadAction<{ isUpdate: boolean, type: 'annualPremium' | 'evidenceOfInsurability' }>) => {
            const { isUpdate, type } = action.payload;
            if (type === 'annualPremium') {
                state.isUpdateAnnualPremium = isUpdate;
            } else if (type === 'evidenceOfInsurability') {
                state.isEvidenceOfInsurability = isUpdate;
            }
        }
    },
});

export const { 
    setAnnualPremiumAmount, 
    setEvidenceNotes,
    setIsUpdateAnnualPremiumAndIoE,
} = annualPremiumEoiSlice.actions;

export const selectAnnualPremiumAmount = (state: RootState) => state.annualPremiumEoi.annualPremiumAmount;
export const selectNMLValue = (state: RootState) => state.annualPremiumEoi.nmlValue;
export const selectNELValue = (state: RootState) => state.annualPremiumEoi.nelValue;
export const selectEvidenceNotes = (state: RootState) => state.annualPremiumEoi.evidenceNotes;
export const selectIsUpdateAnnualPremium = (state: RootState) => state.annualPremiumEoi.isUpdateAnnualPremium;
export const selectIsEvidenceOfInsurability = (state: RootState) => state.annualPremiumEoi.isEvidenceOfInsurability;

export default annualPremiumEoiSlice.reducer;
